import Head from 'next/head'
import Layout from '../components/Layout'
import styles from './new-events.module.scss'


import Link from 'next/link'
import { Text } from '@mantine/core';
import { MenuId } from '../components/Header'
import { ImageData, Workshop, WorkshopStatus } from '../lib/definitions'
import { GetServerSideProps } from 'next'
import { DateTime } from 'luxon'
import { getImageData } from '../lib/data'
import EmailSignupBanner from '../components/EmailSignupBanner'
import CornerBanner from '../components/CornerBanner'
import { UKDate } from '../components/Localization';


export default function NewEvents({data} : {data: {events : Workshop[], imageData: ImageData []}}) {

    //console.log(data.imageDimensions);

    let dimensions = new Map<number, ImageData>();

    data.imageData?.forEach(
        i=>
        {
            dimensions.set(i.id, i);
        }
    )
    
    //console.log(dimensions);


    return (
        <Layout menuId={MenuId.workshops}>
            <Head>
                <title>Upcoming workshops at Raw Umber Studios</title>
                <meta name="description" content="Short, focussed workshops held by classically-trained artists, teaching drawing in charcoal and chalk and painting in oils. Boost your art with structured, practical and inspirational tuition. Ideal for beginner, intermediate and advanced artists."/>
            </Head>
            <div className = {styles.mainContent}>
            <h1>Upcoming workshops</h1>
            <Text>Short, focussed workshops held by classically-trained artists, teaching drawing in charcoal and chalk and painting in oils. Boost your art with structured, practical and inspirational tuition. Ideal for beginner, intermediate and advanced artists.</Text>
           
            <div className={styles.list}>
            {data.events.map(x=> <WorkshopDisplay showLink key={x.id} workshop={x} image={dimensions.get(x.imageId)}/>)}
            </div>
            </div>
            <EmailSignupBanner/>
        </Layout>
    )
}

function WorkshopDisplay(props: {workshop:Workshop, image?: ImageData, showLink?:boolean})
{
    const w = props.workshop;
    const dtFrom = DateTime.fromISO(w.dateStart);
    const dtTo = DateTime.fromISO(w.dateEnd);
    const soldOut = w.ticketsSold>=w.totalTickets || w.status==WorkshopStatus.full;
    const link = "/events/" + w.slug;
    //console.log(props.dimensions);
    //console.log(props.workshop.id);
    let ticketsLeft = w.totalTickets - w.ticketsSold;

    let banner = <></>

    if (soldOut)
    {
        banner = <CornerBanner text="Sold out!" color='white' backgroundColor='#e00'/>
    }
    else if (ticketsLeft<4)
    {
        banner = <CornerBanner text={ticketsLeft + " space" + (ticketsLeft==1?'':'s') + " left"} color='white' backgroundColor='#f60'/>
    }

    return (
        <div className={styles.item}>
    <h2 className={styles.h2}><Link href={link}>{w.title}</Link></h2>
    <div className={styles.imageContainer}>        
        {banner}
        {(props.image && props.image.height) && <Link href={link}><img style={{aspectRatio: props.image.width / props.image.height}} src={"/n/api/thumbnails/" + w.imageId + ".jpg?w=840&t=" + props.image.updatedAt}/></Link>}

    </div>
    <Text><b>Date:</b> 
    {w.length>1?<> <UKDate date={dtFrom}/> - <UKDate date={dtTo}/></>:<> <UKDate date={dtFrom}/></>}
    </Text>
    <Text><b>Tutor:</b> {w.tutor}</Text>
    <Text><b>Cost:</b> £{w.price}</Text>
    {soldOut??<Text><b>SOLD OUT!</b></Text>}
    <Text><i>{w.excerpt}</i></Text>    
    {(props.showLink && !soldOut) && <Link href={link}>Click here for more information and to book</Link>}
    {(props.showLink && soldOut) && <Link href={link}>Click here to join the wait list</Link>}
    
    </div>
    );


}

export const getServerSideProps : GetServerSideProps = async (context)=>
{
    let options = { 
        method: 'GET',  cache: "no-store" as RequestCache
        };

    const result: Workshop[] = await (await fetch(process.env.ADMIN_ROUTE + "/workshops", options)).json();

    let ids : number [] = [];

    result.forEach(x=>
        {
            ids.push(x.imageId);
        });

    let imageData = await getImageData(ids);


    return {
        props: {
          data: 
          { 
              events: result,
              imageData: imageData
          }
        }
    }
  
  }


